import { api } from 'app/config/apiConfig';
import { Pagination } from 'app/types/common';
import { Refund } from '../model/types';

interface Params {
  warehouseId?: string;
  contractId?: string;
  search?: string;
  userId?: string;
  orderBy?: string;
  creationDateFrom?: string;
  creationDateTo?: string;
  isApplicable?: boolean;
}

export const getPaginatedSelfIssuedReceiptsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getPaginatedSelfIssuedReceipts: build.query<Pagination<Refund>, Params | void>({
      query: (args) => ({
        url: '/billing-documents/payments/refunds',
        params: args ? { ...args } : undefined,
      }),
    }),
  }),
});

export const { useGetPaginatedSelfIssuedReceiptsQuery } = getPaginatedSelfIssuedReceiptsApi;
